"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _form = _interopRequireDefault(require("./form"));
var A2AIcon = function A2AIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#a)",
    fill: "#0176D3"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.18 39.245c-5.015 0-9.265-4.082-9.47-9.093-.203-5.01 3.716-9.09 8.73-9.09l11.122.003c5.014 0 9.265 4.082 9.468 9.093.011.2-.018.4-.085.586a1.434 1.434 0 0 1-1.369.95c-.2 0-.401-.04-.59-.117a1.605 1.605 0 0 1-.856-.833 1.552 1.552 0 0 1-.133-.587 6.322 6.322 0 0 0-6.312-6.062l-11.121-.002c-3.387 0-5.958 2.676-5.82 6.06a6.322 6.322 0 0 0 6.312 6.062l11.121.002c.201-.003.402.035.592.11a1.602 1.602 0 0 1 1.008 1.406c.008.2-.024.4-.094.585a1.433 1.433 0 0 1-.8.82 1.483 1.483 0 0 1-.582.11l-11.122-.002Zm20.22.004c-5.015 0-9.265-4.082-9.469-9.093-.01-.2.018-.4.086-.586a1.433 1.433 0 0 1 .788-.832c.182-.078.38-.117.58-.117.201 0 .402.04.59.117a1.603 1.603 0 0 1 .99 1.419 6.322 6.322 0 0 0 6.311 6.062l11.122.002c3.386 0 5.957-2.676 5.82-6.06a6.322 6.322 0 0 0-6.313-6.062l-11.121-.002a1.55 1.55 0 0 1-.591-.11 1.603 1.603 0 0 1-1.009-1.405c-.008-.201.024-.4.094-.585a1.433 1.433 0 0 1 .8-.821c.184-.075.382-.112.583-.11l11.12.003c5.015 0 9.266 4.082 9.47 9.093.203 5.01-3.716 9.09-8.73 9.09L35.4 39.249Z"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "15.436",
    cy: "30.511",
    r: "1.725"
  }), /*#__PURE__*/_react.default.createElement("ellipse", {
    cx: "22.261",
    cy: "30.511",
    rx: "1.65",
    ry: "1.725"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "39.436",
    cy: "30.511",
    r: "1.725"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "46.336",
    cy: "30.511",
    r: "1.725"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v60H0z"
  }))));
};
A2AIcon.defaultProps = {
  viewBox: "0 0 60 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var config = {
  angConfiguration: {
    typeURL: 'http://anypoint.com/vocabs/digital-repository#A2AAsset',
    assetType: 'A2A'
  },
  owner: {
    gusTeam: 'MS Exchange Catalog',
    gusTeamLink: 'https://gus.lightning.force.com/lightning/r/ADM_Scrum_Team__c/a00AH000000in0tYAA/view'
  },
  name: 'A2A',
  pluralName: 'A2As',
  featureFlag: 'a2a-enabled',
  publication: {
    uiForm: _form.default,
    inferredBy: [{
      classifiers: ['agent-card']
    }, {
      typeProperty: 'a2a'
    }],
    files: [{
      id: 'agent-card',
      classifier: 'agent-card',
      mainFileLocationProperty: 'mainFile',
      packaging: 'zip'
    }, {
      id: 'single-agent-card',
      classifier: 'agent-card',
      mainFileLocationProperty: 'mainFile',
      packaging: 'json'
    }, {
      id: 'light-agent-card',
      classifier: 'light-agent-card',
      mainFileLocationProperty: 'mainFile',
      packaging: 'zip'
    }, {
      id: 'fat-agent-card',
      classifier: 'fat-agent-card',
      mainFileLocationProperty: 'mainFile',
      packaging: 'zip'
    }],
    minimumInputSets: [{
      files: [],
      requiredProperties: []
    }, {
      files: ['single-agent-card'],
      requiredProperties: ['mainFile']
    }],
    customProperties: [{
      name: 'provenance',
      storeAsAttribute: true
    }],
    extensionPoints: [{
      name: 'filesGenerator',
      config: {
        outputFileIds: ['light-agent-card', 'fat-agent-card']
      }
    }]
  },
  portal: {
    icon: A2AIcon,
    color: '#32444d'
  }
};
var _default = exports.default = config;
//# sourceMappingURL=config.js.map